import { ReactNode, useCallback, useEffect, useRef, useState } from 'react'
import cn from 'classnames'

import styles from './panel.module.scss';


const TRANSITION_OUT_TIME = 300 as const

type Props = {
  className?: string
  children: (activeActual: boolean, updateSize: () => void) => ReactNode
  active: boolean
  style: Record<string, number | string>
}

const Panel = ({ className, children, active, style }: Props) => {
  const [transition, setTransition] = useState(false)

  const refEl = useRef<HTMLDivElement | null>(null)
  const [height, setHeight] = useState<number>(0)

  const updateSize = useCallback(() => {
    setHeight(refEl.current?.scrollHeight || 0)
  }, [])

  useEffect(() => {
    if (active) {
      setTransition(true)
      setHeight(refEl.current?.scrollHeight || 0)
    } else {
      setTimeout(() => {
        setTransition(active)
      }, TRANSITION_OUT_TIME)
      setHeight(0)
    }
  }, [active])

  return (
    <div
      className={cn(styles.root, className)}
      ref={refEl}
      style={{ ...style, maxHeight: active ? height : 0 }}
    >
      {children(active || transition, updateSize)}
    </div>
  )
}

export default Panel
